<template>
  <div
    class="image-vartical"
    :class="{'disable':!selected}"
    @click="onCkick"
  >
    <div class="center">
      <img class="icon" :src=loadImg>
    </div>
    <div class="text center">{{text}}</div>
  </div>
</template>

<script>
export default {
  name: 'image-vartical',
  props: {
    img: { type: String },
    text: { type: String },
    selected: {type: Boolean}
  },
  computed: {
    loadImg () {
      return require(`@/assets/${this.img}`)
    }
  },
  methods: {
    onCkick (e) {
      this.$emit('click-image', this.text)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
.icon {
  width: 1.8rem;
}
.text {
  font-size: 1rem;
}
.center {
  text-align: center;
}
.image-vartical{
  padding: 0.1rem 0.3rem 0.2rem 0.3rem;
  border-radius: 1rem;
  width:3rem;
  background-color: #cccccc;
  color:#222222;
}
.disable {
  filter: brightness(80%);
  background-color: #aaaaaa;
  color: #222222;
}
</style>



// WEBPACK FOOTER //
// src/components/Molecules/ImageVertical.vue